/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon20Light = forwardRef('TimeClockMoveForwardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.594 3.143A7 7 0 0 1 16.324 7H14a.5.5 0 0 0 0 1h3.5a.5.5 0 0 0 .5-.5V3.748a.5.5 0 0 0-1 0v2.379a8 8 0 1 0 .409 6.89.5.5 0 1 0-.926-.377 7 7 0 1 1-7.89-9.497Z" }),
        React.createElement("path", { d: "M10.003 6.505a.5.5 0 0 0-1 0v2.972c0 .662.374 1.268.967 1.565l2.806 1.405a.5.5 0 0 0 .448-.894l-2.806-1.405a.75.75 0 0 1-.415-.671V6.505Z" })));
});
